import { TmApiClientError } from '@/core/error/transport/tmApiClientError'
import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'

export class TmApiExpectationFailedError extends TmApiClientError {
  public name = 'TmApiExpectationFailedError'

  protected override code: TmTransportHttpErrorCode = 417
}
